"use strict";

angular.module("core")
.constant("PAYMENT_STATUS", {
    "IN_PROGRESS": "in_progress",
    "CANCELLED": "cancelled",
    "FAILED": "failed",
    "SUCCESSFUL": "automatic"
});



//////////////////
// WEBPACK FOOTER
// ./core/payment/payment.constants.js
// module id = 396
// module chunks = 0